import { CompanyPlugin } from "../Models/Common/CompanyPlugin";

export class CommonDataService {
    public static canConnect(callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/common/can-connect`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

        public static isCompanyPluginActive(plugin : CompanyPlugin, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/commoncompany/plugin/${plugin}/active`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}